<template>
  <div v-if="loading" class="loading">Aguarde ...</div>
  <div v-else class="container-fluid">
    <div class="text-left">
      <h3>
        <router-link to="/tarefas">Tarefas</router-link>
      </h3>
      <small>{{tarefas.length}} resultado(s) encontrados</small>
      <small v-if="this.$route.query.s"> que contém '{{this.$route.query.s}}'</small>
    </div>
    <div class="text-left row">
      <div class="col-sm-12">
        <h4>Filtros
          <a @click.prevent="showFilters=true" v-if="!showFilters" class="glyphicon glyphicon-eye-open"></a>
          <a @click.prevent="showFilters=false" v-if="showFilters" class="glyphicon glyphicon-eye-close"></a>
        </h4>
      </div>
      <template v-if="showFilters">
        <div class="form-group col-sm-2">
          <label class="control-label">Responsável</label>
          <select v-model="filters.coduser" class="form-control">
              <option value="*">Alguem (Todos)</option>
              <option value="2">Fabio</option>
              <option value="3">Felipe</option>
              <option value="4">Jair</option>
              <option value="5">Josue</option>
              <option value="6">Lucas</option>
              <option value="7">Prado</option>
              <option value="8">Regis</option>
              <option value="9">Roberto</option>
              <option value="10">Rodrigo</option>
              <option value="11">Sanguine</option>
              <option value="12">Valni</option>
          </select>
        </div>
        <div class="form-group col-sm-2">
          <label class="control-label">Urgência</label>
          <select v-model="filters.flag" class="form-control">
              <option value="*">Todos</option>
              <option value="0">Imediato</option>
              <option value="1">Urgente</option>
              <option value="2">Moderada</option>
              <option value="3">Normal</option>
              <option value="4">Quando possível</option>
          </select>
        </div>
        <div class="form-group col-sm-2">
          <label class="control-label">Situação</label>
          <select v-model="filters.situacao" class="form-control">
            <option value="*">Todos</option>
            <option value="1">Abertos</option>
            <option value="2">Abertos e Aguardando</option>
            <option value="3">Aguardando</option>
            <option value="4">Resolvido</option>
          </select>
        </div>
        <div class="col-sm-2">
          <label for="">Data Minima</label>
          <div class="input-group">
            <input ref="dtmindisplay" value="01/01/1900" type="text" class="form-control" disabled>
            <div class="input-group-btn">
              <button class="btn btn-primary" @click="showCalendarMin=true"><i class="glyphicon glyphicon-calendar"></i></button>
              <Calendario v-if="showCalendarMin" @pickDate="setDateMin" class="calendario"></Calendario>
            </div>
          </div>
        </div>
        <div class="col-sm-2">
          <label for="">Data Máxima</label>
          <div class="input-group">
            <input ref="dtmaxdisplay" value="31/12/9999" type="text" class="form-control" disabled>
            <div class="input-group-btn">
              <button class="btn btn-primary" @click="showCalendarMax=true"><i class="glyphicon glyphicon-calendar"></i></button>
              <Calendario v-if="showCalendarMax" @pickDate="setDateMax" class="calendario"></Calendario>
            </div>
          </div>
        </div>
        <div class="col-sm-2">
          <label>Aplicar filtro</label>
          <button @click.prevent="searchWithFilters()" class="btn btn-primary">Pesquisar</button>
        </div>
      </template>
    </div>
    <table>
      <tr>
        <td></td>
        <td>razao</td>
        <td>descrição</td>
        <td>prazo</td>
        <td>contato</td>
        <td>situação</td>
      </tr>
      <tr v-for="tarefa,index in tarefas" :class="isUrgent(tarefa.dt_limite, tarefa.flag, tarefa.situacao, index)">
        <td><a @click.prevent="select4edit(tarefa.cod)" class="glyphicon glyphicon-pencil" title="Editar"></a></td>
        <td>{{tarefa.razao}}<br><small>{{tarefa.fantasia}}</small></td>
        <td>
          {{tarefa.descr}}<br>
          <b>{{tarefa.autornome}} » {{tarefa.responsavelnome}}</b>
        </td>
        <td class="text-center">
          {{tarefa.dt_limite}}<br>
          <b>{{tarefa.flagdescr}}</b>
        </td>
        <td>
            <span v-for="telefone in tarefa.telefone" class="nowrap">{{maskTelefone(telefone.numero)}}</br></span>
        </td>
        <td class="text-center">
          <b v-if="tarefa.atrasado && tarefa.situacao !== '6'">(PRAZO!)<br></b>
          {{tarefa.situacaodescr}}<br>
          <b>{{tarefa.solucionadornome}}</b>
        </td>
      </tr>
    </table>
    <br><br><br>
  </div>
</template>

<script>
  import Calendario from './Calendar.vue'
  import Mask from './Mask.js'
  export default {
    name: 'datalist',
    components: { Calendario },
    data () {
      return {
        showFilters: false,
        showCalendarMin: false,
        showCalendarMax: false,
        loading: false,
        dthoje: undefined,
        filters: {
          coduser: '*',
          flag: '*',
          situacao: '*',
          dtmin: '1900-01-01 00:00:00',
          dtmax: '9999-12-31 00:00:00'
        },
        tarefas: []
      }
    },
    methods: {
      load (params = '') {
        const url = './api/php/gettarefa.php'
        this.$http.post(url, JSON.stringify(params)).then(
          function (response) {
            console.log(response.body)
            if (response.body.length > 0) {
              this.tarefas = response.body
            } else {
              this.tarefas = []
            }
          },
          function (error) {
            console.log(error)
          }
        )
      },
      select4edit (cod) {
        this.$router.push({path: `/tarefa/u/${cod}`})
      },
      setDateMin (dt) {
        const aaaa = dt.substring(0, 4)
        const mm = dt.substring(4, 6)
        const dd = dt.substring(6, 8)
        this.filters.dtmin = aaaa + '-' + mm + '-' + dd + ' 00:00:00'
        this.showCalendarMin = false
        this.$refs.dtmindisplay.value = dd + '/' + mm + '/' + aaaa
      },
      setDateMax (dt) {
        const aaaa = dt.substring(0, 4)
        const mm = dt.substring(4, 6)
        const dd = dt.substring(6, 8)
        this.filters.dtmax = aaaa + '-' + mm + '-' + dd + ' 00:00:00'
        this.showCalendarMax = false
        this.$refs.dtmaxdisplay.value = dd + '/' + mm + '/' + aaaa
      },
      searchWithFilters () {
        this.load({'keyword': this.$route.query.s, 'filters': this.filters})
        console.log('Busca por Filtros...')
      },
      isUrgent (dtLimite, flag, situacao, index) {
        if (this.dthoje === undefined) this.dthoje = new Date().toISOString().slice(0, 10).replace(/-/g, '')
        const atrasado = dtLimite.slice(0, 10).replace(/-/g, '') < this.dthoje
        this.tarefas[index].atrasado = atrasado
        flag = parseInt(flag)
        situacao = parseInt(situacao)
        if (situacao === 6) {
          return 'text-muted'
        } else if (!atrasado) {
          if (flag === 0 && situacao < 6) {
            return 'bg-danger'
          } else if (flag < 3 && situacao < 6) {
            return 'text-warning'
          } else {
            return ''
          }
        } else {
          if (flag === 0) {
            return 'bg-danger text-danger'
          } else if (flag < 3) {
            return 'bg-warning text-danger'
          } else if (flag === 3) {
            return 'text-warning'
          } else {
            return 'text-warning'
          }
        }
      }
    },
    created: function () {
      this.maskTelefone = Mask.telefone
      const keyword = this.$route.query.s
      this.load({'keyword': keyword, 'filters': false})
    },
    watch: {
      '$route' (to, from) {
        const keyword = this.$route.query.s
        this.load({'keyword': keyword, 'filters': false})
      }
    }
  }
</script>

<style scoped>
    .container-fluid {
      width: 80vw;
      margin: auto;
    }
    table {
      font: 12px sans-serif;
      color: #333;
      border-collapse: collapse;
      outline: 2px solid #333;
      text-align: left;
      width: 100%;
    }
    table tr:not(.*) {
      background: #fcfcfc;
    }
    table tr:nth-child(2n+1):not(.*) {
      background: #f1f1f1;
    }
    table tr:hover{
      background: #ccc;
    }
    table tr:first-child {
      background: #333;
      color: #fff;
      text-transform: uppercase;
    }
    table tr td {
      padding: 5px;
    }
    table tr td small {
      color: #777;
    }
    a.glyphicon {
      text-decoration: none;
    }
    .calendario {
      position: absolute;
      top: 0px;
      left: 0px;
      z-index: 100;
    }
    .nowrap {
      white-space: nowrap;
    }
    @media (max-width: 762px) {
      .container-fluid {
        width: 100vw;
        margin: 0;
        padding: 0;
      }
      table {
        font: 10px sans-serif;
        width: 100vw;
      }
      .lt500 {
        display: none;
      }
    }
</style>


// WEBPACK FOOTER //
// src/components/TarRel.vue